module.exports = __webpack_public_path__ + "img/black.84f38c22.jpg";